import { useRouter } from '@application/utils';
import type { CardItemLitterData } from '@presentation/components';
import { MtWishlistPage } from '@presentation/pages';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useFormatLitters } from '../LitterListPageController/api/useFormatLitters';
import { useRemoveBookmark } from '../LitterPageController/api/useRemoveBookmark';
import { useGetBookmarks } from './api/useGetBookmarks';

export const MtWishlistPageController: FC = () => {
  const { navigateToRoute } = useRouter();

  const { bookmarks, bookmarksLoading } = useGetBookmarks();
  const { removeBookmark } = useRemoveBookmark();
  const { formattedLitters } = useFormatLitters(bookmarks?.map((b) => b.litter));

  const items = useMemo((): CardItemLitterData[] => {
    return (formattedLitters ?? []).map((litter) => ({
      ...litter,
      isWishlisted: true,
      onWishlistClick: () => {
        if (litter?.id) {
          removeBookmark(litter?.id);
        }
      },
    }));
  }, [formattedLitters, removeBookmark]);

  return (
    <MtWishlistPage
      items={items}
      onLitterListClick={() => navigateToRoute('litterList')}
      loading={bookmarksLoading}
    />
  );
};
